<template>
  <div id="app">
    <AppHeader :isBoss="isBoss" v-if="isAuth" />
    <AppPage :isBoss="isBoss" />
<!--    <AppFooter />-->
  </div>
</template>

<script>
import AppHeader from '@/components/Header.vue'
import AppPage   from '@/components/Page.vue'
import AppFooter from '@/components/Footer.vue'

import AuthModal from '@/components/modals/AuthModal.vue'
import axios from "axios";
import qs from "qs";

export default {
  components: {
    AppHeader,
    AppPage,
    AppFooter,
    AuthModal
  },
  data() {
      return {
        isAuth: false,
        isBoss: false
      }
  },
  created() {
    const self = this;
      axios(process.env.VUE_APP_BACKEND_HOST + '/api/check_session', {
              method: "post",
              withCredentials: true,
              headers : {'Content-Type': 'application/x-www-form-urlencoded'}
          }).then(function(response) {
                self.isAuth = response.data.status.auth;
                self.isBoss = response.data.status.isBoss;
                if (!self.isAuth) {
                  self.$router.push("/login");
                }
            })
      ;
  }
}
</script>
